/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 * 
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import getChoiceIconStyle from "assets/getChoiceIconStyle";

const A_minus = ({ isActive = false }) => {
  const fill = getChoiceIconStyle(isActive);
  return (
    <svg
      width="80"
      height="80"
      viewBox="10 10 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="105" height="105" fill="none" />
      <path
        d="M38.184 61.696C37.8107 61.696 37.512 61.612 37.288 61.444C37.064 61.276 36.9333 61.052 36.896 60.772C36.8587 60.492 36.9147 60.1747 37.064 59.82L44.652 42.796C44.8387 42.348 45.072 42.0307 45.352 41.844C45.6507 41.6573 45.9773 41.564 46.332 41.564C46.668 41.564 46.976 41.6573 47.256 41.844C47.5547 42.0307 47.7973 42.348 47.984 42.796L55.572 59.82C55.74 60.1747 55.8053 60.5013 55.768 60.8C55.7307 61.08 55.6093 61.304 55.404 61.472C55.1987 61.6213 54.9093 61.696 54.536 61.696C54.1253 61.696 53.7987 61.5933 53.556 61.388C53.3133 61.1827 53.0987 60.8653 52.912 60.436L50.952 55.9L52.268 56.684H40.34L41.628 55.9L39.696 60.436C39.5093 60.884 39.304 61.2107 39.08 61.416C38.856 61.6027 38.5573 61.696 38.184 61.696ZM46.276 44.98L42.048 55.004L41.348 54.332H51.232L50.588 55.004L46.332 44.98H46.276ZM59.0377 55.172C58.7017 55.172 58.4217 55.06 58.1977 54.836C57.9737 54.612 57.8617 54.3413 57.8617 54.024C57.8617 53.688 57.9737 53.4173 58.1977 53.212C58.4217 52.988 58.7017 52.876 59.0377 52.876H65.1977C65.515 52.876 65.7857 52.988 66.0097 53.212C66.2337 53.4173 66.3457 53.688 66.3457 54.024C66.3457 54.3413 66.2337 54.612 66.0097 54.836C65.7857 55.06 65.515 55.172 65.1977 55.172H59.0377Z"
        fill={fill}
      />
    </svg>
  );
};

export default A_minus;
